import { Component, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard-cctv-streaming',
  templateUrl: './dashboard-cctv-streaming.component.html',
  styleUrls: ['./dashboard-cctv-streaming.component.scss']
})
export class DashboardCctvStreamingComponent implements OnInit {
  cctvstreaming: any []=[];
  selected_value: any;
  show: boolean = true;
  filterBy: any;
  id: any;
  searchkey: string = '';
  public searchTerm: string = '';
  hide: boolean = false;
  constructor(public campuscctvserviceservice: CampuscctvserviceService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.cctvcamerastreaming()
  }

  cctvcamerastreaming() {
    this.selected_value = "STATE"
    this.campuscctvserviceservice.getcctvstreaming(this.selected_value).subscribe((res) => {
      this.cctvstreaming = res;
    })
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } });
  }


  onOptionsSelected(e: any) {
    this.show = true
    this.selected_value = e.target.value
    if (this.selected_value === 'STATE' || this.selected_value === 'CITY' || this.selected_value === 'CAMPUS') {
      this.campuscctvserviceservice.getcctvstreaming(this.selected_value).subscribe((res) => {
        this.cctvstreaming = res;
        this.hide = false;
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigatertochange(data: any) {
    console.log(data);
    this.filterBy = data.filterBy
    this.id = data.id;
    this.hide = true;
    if (this.filterBy == "STATE") {
      localStorage.setItem('stateId', data.id);
      this.campuscctvserviceservice.getstreamingright(this.filterBy, this.id).subscribe((res) => {
        if (res == null) {
          this.cctvstreaming = [];
        } else {
          console.log(res);
          this.cctvstreaming = res;
          // this.hide = true;
        }
      })
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    } else if (this.filterBy == "CITY") {
      localStorage.setItem('cityId', data.id);
      this.campuscctvserviceservice.getstreamingright(this.filterBy, this.id).subscribe((res) => {
        if (res == null) {
          this.cctvstreaming = [];
        } else {
          console.log(res);
          this.cctvstreaming = res;
          this.hide = true;
        }
      })
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
    else if (this.filterBy == "CAMPUS") {
      localStorage.setItem('campusId', data.id);
      this.show = false;
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigateBackward(data: any) {
    const filterBy = data.filterBy
    const id = data.id;
    if (filterBy == 'CAMPUS' && this.show == false) {
      this.campuscctvserviceservice.getstreamingright("CITY", localStorage.getItem('cityId')).subscribe((res) => {
        this.cctvstreaming = res;
        this.show = true;
        console.log(res);
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
      if (this.selected_value === "CAMPUS") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvstreaming(this.selected_value).subscribe((res) => {
          this.cctvstreaming = res;
          this.spinner.hide();
        });

      }
    } 
    else if (filterBy == 'CAMPUS' && this.show == true) {
      if (localStorage.getItem('stateId')) {
        this.campuscctvserviceservice.getstreamingright("STATE", localStorage.getItem('stateId')).subscribe((res) => {
          this.cctvstreaming = res;
          console.log(res);
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      else {
        this.campuscctvserviceservice.getcctvstreaming(this.selected_value).subscribe((res) => {
          // localStorage.setItem('stateId', res.id);
          this.cctvstreaming = res;
          console.log(this.cctvstreaming);
          this.spinner.hide();
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      if (this.selected_value === "CITY") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvstreaming(this.selected_value).subscribe((res) => {
          this.cctvstreaming = res;
          this.spinner.hide();
        });
      }
    }
    else if (filterBy == "CITY") {
      this.hide = false;
      this.cctvcamerastreaming();
    }

  }

  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
  }
}
